import { autorun } from 'mobx';
import { getSnapshot, Instance } from 'mobx-state-tree';
import React from 'react';
import { IEntityStore } from '../main/entities';
import { mg } from '../mg/mg';
import { Communicator } from '../services/CommSvc';
import { AuthStore } from './AuthStore';
import { EntityManagerStore } from './EntityManagerStore';
import { ILocationStore, LocationStore } from './LocationStore';
import { Multirepo } from './Multirepo';
import { AppPageStores, newAppPageStores } from './parts/AppPageStores'; //REOCTOBUILD
import { ProfileStore } from './ProfileStore';
import { ReoctoStore } from './ReoctoStore';

export class Omnistore {
	readonly authStore = AuthStore.create(mg.storage.get('auth', {}));
	readonly reoctoStore = ReoctoStore.create();
	readonly locationStore = new LocationStore();
	readonly entityManagerStore = EntityManagerStore.create();
	readonly multirepo = Multirepo.create();
	readonly profileStore = ProfileStore.create();
	readonly appPageStores = newAppPageStores();

	readonly communicator = new Communicator(() => this.reoctoStore, () => this.authStore);

	static newOmnistore() : IOmnistore {
		const r = new Omnistore();
		r.authStore.sanitize();
		autorun(() => mg.storage.put('auth', getSnapshot(r.authStore)));
		return r;
	}
}

type IStoreOrId = undefined | string | {id: string}
type IListFn = () => Array<IStoreOrId>
export interface IEntityManagerStore {
	byStoreId(storeId: string) : IEntityStore
	get(name: string, masterId?: number) : IEntityStore

	subscribe(subscriberId: string, listFn: IListFn) : void
	unsubscribe(subscriberId: string) : void

	step() : void
	clear() : void
}

export interface IOmnistore {
	communicator: Communicator
	authStore: Instance<typeof AuthStore>
	reoctoStore: Instance<typeof ReoctoStore>
	locationStore: ILocationStore
	entityManagerStore: IEntityManagerStore
	multirepo: Instance<typeof Multirepo>
	profileStore: Instance<typeof ProfileStore>
	appPageStores: Instance<typeof AppPageStores>
}

const omnistore = Omnistore.newOmnistore();

export function getOmnistore(): IOmnistore {
	return omnistore;
}

const myContext = React.createContext<IOmnistore | undefined>(undefined);

export const OmnistoreProvider = ({children} : {children: React.ReactNode}) => {
	return <myContext.Provider value={omnistore}>{children}</myContext.Provider>;
};

export const useOmnistore = () => {
	const store = React.useContext(myContext);
	if (!store) throw new Error('Missing omnistore.');
	return store;
};
